export default __webpack_public_path__ + "static/media/trust_platform.bf65db81.png";